import type { WithActiveBranchId } from '@app/api/shared';

type TechnologicalMapsWithBranchRequest = Partial<WithActiveBranchId>;

export enum TechnologicalMapsEndpoints {
  GetClientServiceProductUsages = 'GetClientServiceProductUsages',
  SaveClientServiceProductUsages = 'SaveClientServiceProductUsages',
  DeleteClientServiceProductUsages = 'DeleteClientServiceProductUsages',
  GetWarehouses = 'GetWarehouses',
  GetProductsList = 'GetProductsList',
  DeleteTechnologicalMap = 'DeleteTechnologicalMap',
  GetRecordTechnologicalMap = 'GetRecordTechnologicalMap',
}

export interface ModelServiceProductUsage {
  Id: number;
  ClientServiceId: number;
  ClientService: string | null;
  WarehouseId: number;
  Warehouse: string | null;
  ProductId: number;
  Product: string | null;
  UsageAmount: number;
}

export interface TechnologicalMapsModelItem {
  Id: number;
  IdS: string | null;
  Name: string | null;
}

export interface ModelTechnologicalMapOperation {
  Id: number;
  WarehouseId: number;
  Warehouse: string | null;
  ProductItemId: number;
  ProductDesc: string | null;
  ClientServiveId: number;
  ClientService: string | null;
  Action: string | null;
  ActionAmount: string | null;
  IsCredit: boolean;
}

export interface ModelTechnologicalMap {
  Id: number;
  RecordId: number;
  TimeApplied: string;
  Operations: ModelTechnologicalMapOperation[] | null;
}

export type GetClientServiceProductUsagesRequest =
  TechnologicalMapsWithBranchRequest & {
    clientServiceId?: number;
  };

export type SaveClientServiceProductUsagesRequest =
  TechnologicalMapsWithBranchRequest & {
    data: ModelServiceProductUsage[];
  };

export type DeleteClientServiceProductUsagesRequest =
  TechnologicalMapsWithBranchRequest & {
    clientServiceId?: number;
  };

export type GetWarehousesRequest = TechnologicalMapsWithBranchRequest & {
  warehouseIds?: number[];
};

export type GetProductsListRequest = TechnologicalMapsWithBranchRequest & {
  productIds?: number[];
};

export type DeleteTechnologicalMapRequest =
  TechnologicalMapsWithBranchRequest & {
    mapId?: number;
  };

export type GetRecordTechnologicalMapRequest =
  TechnologicalMapsWithBranchRequest & {
    recordId?: number;
  };

export type GetClientServiceProductUsagesResponse = ModelServiceProductUsage[];
export type SaveClientServiceProductUsagesResponse = ModelServiceProductUsage[];
export type DeleteClientServiceProductUsagesResponse = void;
export type GetWarehousesResponse = TechnologicalMapsModelItem[];
export type GetProductsListResponse = TechnologicalMapsModelItem[];
export type DeleteTechnologicalMapResponse = void;
export type GetRecordTechnologicalMapResponse = ModelTechnologicalMap;
